export function generateStructureKey(alias: string, maxlen?: number) {
    const orig = alias;
    const rt: any = {
        'ä': 'ae',
        'ö': 'oe',
        'ü': 'ue',
        'ß': 'ss',
        'Ä': 'ae',
        'Ö': 'oe',
        'Ü': 'ue',
        '$': '',
        '*': '',
        '/': '',
        '>': '',
        '#': '',
        '<': '',
        ':': '',
        '|': '',
        '"': '',
        '-': '_',
        ' ': '_'
    };
    alias = alias.toLowerCase();
    const length = alias.length;
    Object.keys(rt).map((c1: string) => {
        const c2 = rt[c1];
        for (let i = 0; i < length; i++) {
            alias = alias.replace(c1, c2);
        }
    });

    alias = alias.replace(/[\W]+/g, '');

    if (!alias || alias.trim() === '') {
        alias = new Date().getTime().toString();
    }
    if (maxlen && maxlen < alias.length) {
        alias = alias.substr(0, maxlen);
    }
    // console.log('StructureKey:' + orig + ' ->  ' + alias);
    return alias;
}
